module.exports = __webpack_public_path__ + "img/icon-chevron-right-grey.5f2d2bf9.svg";